<template>
  <div class="m-rank">
    <img v-if="getRank === 1" class="m-rank__media"
     :class="['m-rank__media--3']"
     src="~@/assets/images/rank/rank__apprentice.svg" alt="Rank 1 - Apprentice"/>
    <img v-if="getRank === 2" class="m-rank__media"
     :class="['m-rank__media--'] + getRank"
     src="~@/assets/images/rank/rank__junior-surveyor.svg" alt="Rank 2 - Junior Surveyor"/>
    <img v-if="getRank === 3" class="m-rank__media"
     :class="['m-rank__media--'] + getRank"
     src="~@/assets/images/rank/rank__associate.svg" alt="Rank 3 - Associate"/>
    <img v-if="getRank === 4" class="m-rank__media"
     :class="['m-rank__media--'] + getRank"
     src="~@/assets/images/rank/rank__partner.svg" alt="Rank 4 - Partner"/>
    <!-- <span class="m-rank__number">{{ getRank }}</span>
    <span class="m-rank__title">{{ getRankName(getRank).rank_name }}</span> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['getRankName', 'getRank']),
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/header/Rank.vue